import React from "react"
import { HStack } from "@chakra-ui/react"

const PermissionsLayoutModule = ({ children }) => {
  return (
    <HStack
      alignItems="center"
      justifyContent="center"
      spacing="1em"
      width="100%"
      bg="white"
      borderRadius="0.75em"
      boxShadow="lg"
      height="2em"
    >
      {children}
    </HStack>
  )
}

export default PermissionsLayoutModule
